import {
    useContext,
    useEffect,
    useMemo,
    type FC
} from "react";
import type IMenubarContentProps from "./type";
import type {
    DropdownMenuContextType
} from "../../../dropdownMenu/type";
import {
    DropdownMenuContext
} from "../../../dropdownMenu/context";
import {
    warnOnce
} from "../../../../utils/development";
import DropdownMenu from "../../../dropdownMenu";

const MenubarContent: FC<IMenubarContentProps> = ({
    align = "start",
    children,
    ...props
}) => {
    const rootContext = useContext(DropdownMenuContext);

    const value = useMemo<DropdownMenuContextType | undefined>(() => {
        if(!rootContext) {
            return undefined;
        }

        return {
            ...rootContext,
            align
        };
    }, [
        rootContext,
        align
    ]);

    useEffect(() => {
        if(value) {
            return;
        }

        warnOnce({
            message: "Menubar.Content: must be rendered inside <Menubar.Menu>."
        });
    }, [
        value
    ]);

    if(!value) {
        return null;
    }

    return <DropdownMenuContext.Provider
        value={value}
    >
        <DropdownMenu.Content
            {...props}
        >
            {children}
        </DropdownMenu.Content>
    </DropdownMenuContext.Provider>;
};
export default MenubarContent;
